// Registers the service worker that keeps ClippCut working offline after the
// first visit. Production builds only.
export function register() {
  if (process.env.NODE_ENV !== 'production' || !('serviceWorker' in navigator)) return
  window.addEventListener('load', () => {
    navigator.serviceWorker.register(`${process.env.PUBLIC_URL}/service-worker.js`).catch((e) => console.warn('Offline mode unavailable', e))
  })
}
